import React from 'react'
import { clsx } from '../../../utils/helper'

const ButtonRound = React.forwardRef(
    ({ className, secondary, outline, children, ...props }, ref) => {
        const classes = clsx([
            'app-btn-round',
            outline && 'outline',
            secondary && 'secondary',
            className,
        ])
        return (
            <button ref={ref} className={classes} {...props}>
                {children}
            </button>
        )
    }
)

export default ButtonRound
